export const currencyConfig = {
  AF: {
    symbol: "؋",
    name: "Afghan Afghani",
    currency: "AFN",
    locale: "fa-AF",
  },

  AL: {
    symbol: "L",
    name: "Albanian Lek",
    currency: "ALL",
    locale: "sq-AL",
  },

  DZ: {
    symbol: "د.ج",
    name: "Algerian Dinar",
    currency: "DZD",
    locale: "ar-DZ",
  },

  AR: {
    symbol: "$",
    name: "Argentine Peso",
    currency: "ARS",
    locale: "es-AR",
  },

  AU: {
    symbol: "$",
    name: "Australian Dollar",
    currency: "AUD",
    locale: "en-AU",
  },

  AT: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "de-AT",
  },

  BD: {
    symbol: "৳",
    name: "Bangladeshi Taka",
    currency: "BDT",
    locale: "bn-BD",
  },

  BE: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "nl-BE",
  },

  BR: {
    symbol: "R$",
    name: "Brazilian Real",
    currency: "BRL",
    locale: "pt-BR",
  },

  CA: {
    symbol: "$",
    name: "Canadian Dollar",
    currency: "CAD",
    locale: "en-CA",
  },

  CN: {
    symbol: "¥",
    name: "Chinese Yuan",
    currency: "CNY",
    locale: "zh-CN",
  },

  DK: {
    symbol: "kr",
    name: "Danish Krone",
    currency: "DKK",
    locale: "da-DK",
  },

  EG: {
    symbol: "£",
    name: "Egyptian Pound",
    currency: "EGP",
    locale: "ar-EG",
  },

  FI: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "fi-FI",
  },

  FR: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "fr-FR",
  },

  DE: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "de-DE",
  },

  IN: {
    symbol: "₹",
    name: "Indian Rupee",
    currency: "INR",
    locale: "en-IN",
  },

  ID: {
    symbol: "Rp",
    name: "Indonesian Rupiah",
    currency: "IDR",
    locale: "id-ID",
  },

  IE: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "en-IE",
  },

  IT: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "it-IT",
  },

  JP: {
    symbol: "¥",
    name: "Japanese Yen",
    currency: "JPY",
    locale: "ja-JP",
  },

  MY: {
    symbol: "RM",
    name: "Malaysian Ringgit",
    currency: "MYR",
    locale: "ms-MY",
  },

  MX: {
    symbol: "$",
    name: "Mexican Peso",
    currency: "MXN",
    locale: "es-MX",
  },

  NL: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "nl-NL",
  },

  NZ: {
    symbol: "$",
    name: "New Zealand Dollar",
    currency: "NZD",
    locale: "en-NZ",
  },

  NO: {
    symbol: "kr",
    name: "Norwegian Krone",
    currency: "NOK",
    locale: "nb-NO",
  },

  PK: {
    symbol: "₨",
    name: "Pakistani Rupee",
    currency: "PKR",
    locale: "ur-PK",
  },

  PH: {
    symbol: "₱",
    name: "Philippine Peso",
    currency: "PHP",
    locale: "en-PH",
  },

  RU: {
    symbol: "₽",
    name: "Russian Ruble",
    currency: "RUB",
    locale: "ru-RU",
  },

  SA: {
    symbol: "﷼",
    name: "Saudi Riyal",
    currency: "SAR",
    locale: "ar-SA",
  },

  SG: {
    symbol: "$",
    name: "Singapore Dollar",
    currency: "SGD",
    locale: "en-SG",
  },

  ZA: {
    symbol: "R",
    name: "South African Rand",
    currency: "ZAR",
    locale: "en-ZA",
  },

  KR: {
    symbol: "₩",
    name: "South Korean Won",
    currency: "KRW",
    locale: "ko-KR",
  },

  ES: {
    symbol: "€",
    name: "Euro",
    currency: "EUR",
    locale: "es-ES",
  },

  LK: {
    symbol: "Rs",
    name: "Sri Lankan Rupee",
    currency: "LKR",
    locale: "si-LK",
  },

  SE: {
    symbol: "kr",
    name: "Swedish Krona",
    currency: "SEK",
    locale: "sv-SE",
  },

  CH: {
    symbol: "CHF",
    name: "Swiss Franc",
    currency: "CHF",
    locale: "de-CH",
  },

  TH: {
    symbol: "฿",
    name: "Thai Baht",
    currency: "THB",
    locale: "th-TH",
  },

  TR: {
    symbol: "₺",
    name: "Turkish Lira",
    currency: "TRY",
    locale: "tr-TR",
  },

  AE: {
    symbol: "د.إ",
    name: "UAE Dirham",
    currency: "AED",
    locale: "ar-AE",
  },

  GB: {
    symbol: "£",
    name: "British Pound",
    currency: "GBP",
    locale: "en-GB",
  },

  US: {
    symbol: "$",
    name: "US Dollar",
    currency: "USD",
    locale: "en-US",
  },

  VN: {
    symbol: "₫",
    name: "Vietnamese Dong",
    currency: "VND",
    locale: "vi-VN",
  },
};